
/* ---- Home Page First Fold Globe.GL */

// Heading Text Scramble Animation Code 
  var words = document.getElementById('scrambleText');
  var wordArray = [];
  var currentWord = 0;

  if (words) {
    words.style.opacity = 1;
    splitLetters(words);
  }

  function changeWord() {
    var cw = wordArray[currentWord];
    var nw = currentWord === 0 ? wordArray[1] : wordArray[0];

    if (cw) {
      for (var i = 0; i < cw.length; i++) {
        animateLetterOut(cw, i);
      }
    }

    if (nw) {
      for (var i = 0; i < nw.length; i++) {
        nw[i].className = 'letter behind';
        animateLetterIn(nw, i);
      }
    }

    currentWord = (currentWord === 0) ? 1 : 0;
  }

  function animateLetterOut(cw, i) {
    setTimeout(function () {
      cw[i].className = 'letter out';
    }, i * 80);
  }

  function animateLetterIn(nw, i) {
    setTimeout(function () {
      nw[i].className = 'letter in';
    }, 340 + (i * 80));
  }

  function splitLetters(word) {
    var content = word.textContent;
    word.textContent = '';
    var letters = [];
    for (var i = 0; i < content.length; i++) {
      var letter = document.createElement('span');
      letter.className = 'letter';
      letter.innerHTML = content.charAt(i);
      word.appendChild(letter);
      letters.push(letter);
    }
    wordArray.push(letters);
  }

  setTimeout(changeWord, 3000);
  // setInterval(changeWord, 3000);

  var wordsObserver = new IntersectionObserver(function (entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        changeWord();
      }
    });
  }, { threshold: 1.0 }); // Adjust threshold as needed

  // Connect the observer to the target element
  if (words) {
    wordsObserver.observe(words);
  }


  if (document.querySelector('.slide-show-container .video__container')) {
    const COUNTRY = 'India';
    const OPACITY = 0.4;
    const globeContainer = document.querySelector('.slide-show-container .video__container');
    const myGlobe = Globe()(globeContainer)
      (document.querySelector('.slide-show-container .video__container'))
      .globeImageUrl('//unpkg.com/three-globe/example/img/earth-night.jpg')
      .backgroundImageUrl('//unpkg.com/three-globe/example/img/night-sky.png')
      .pointOfView({ lat: 20.5937, lng: 78.9629, altitude: 2.0 }) // aim at India as centroid
      .arcStartLat(d => +d.srcAirport.lat)
      .arcStartLng(d => +d.srcAirport.lng)
      .arcEndLat(d => +d.dstAirport.lat)
      .arcEndLng(d => +d.dstAirport.lng)
      .arcDashLength(0.25)
      .arcDashGap(1)
      .arcDashInitialGap(() => Math.random())
      .arcDashAnimateTime(4000)
      .arcColor(d => [`rgba(0, 255, 0, ${OPACITY})`, `rgba(255, 0, 0, ${OPACITY})`])
      .arcsTransitionDuration(0)

      .pointColor(() => 'orange')
      .pointAltitude(0)
      .pointRadius(0.05)
      .pointsMerge(true)
      .enablePointerInteraction(true);

    // load data

    const airportParse = ([airportId, name, city, country, iata, icao, lat, lng, alt, timezone, dst, tz, type, source]) => ({ airportId, name, city, country, iata, icao, lat, lng, alt, timezone, dst, tz, type, source });
    const routeParse = ([airline, airlineId, srcIata, srcAirportId, dstIata, dstAirportId, codeshare, stops, equipment]) => ({ airline, airlineId, srcIata, srcAirportId, dstIata, dstAirportId, codeshare, stops, equipment });

    Promise.all([
      fetch('https://raw.githubusercontent.com/jpatokal/openflights/master/data/airports.dat').then(res => res.text())
        .then(d => d3.csvParseRows(d, airportParse)),
      fetch('https://raw.githubusercontent.com/jpatokal/openflights/master/data/routes.dat').then(res => res.text())
        .then(d => d3.csvParseRows(d, routeParse))
    ]).then(([airports, routes]) => {

      const byIata = indexBy(airports, 'iata', false);

      const filteredRoutes = routes
        .filter(d => byIata.hasOwnProperty(d.srcIata) && byIata.hasOwnProperty(d.dstIata)) // exclude unknown airports
        .filter(d => d.stops === '0') // non-stop flights only
        .map(d => Object.assign(d, {
          srcAirport: byIata[d.srcIata],
          dstAirport: byIata[d.dstIata]
        }))
        .filter(d => d.srcAirport.country === COUNTRY && d.dstAirport.country !== COUNTRY); // international routes from country

      myGlobe
        .arcsData(filteredRoutes);
    });

    myGlobe.controls().autoRotate = true;
    myGlobe.controls().autoRotateSpeed = 1.5;
    myGlobe.controls().enableZoom = false;
  }



  document.addEventListener("DOMContentLoaded", function(){
    gsap.registerPlugin(ScrollToPlugin);
    const btn = document.querySelector('.box')
    if (btn) {
      btn.addEventListener("click", () => {
        gsap.to(window, { duration: 1.5, scrollTo: { y: "#services_testimonial_slider", offsetY: 120 } });
      })
    }
  })



/** ---- Brand Logo's JS ---- **/

  const images = gsap.utils.toArray('.brand_logos img');
  const columnsLength = images.length;

  images.forEach((image, index) => {
    const randomOffset = gsap.utils.random(["-200%", "200%"]);
    const isEven = index % 2 === 0;

    const tl = gsap.timeline({
      repeat: -1,
      delay: -columnsLength + index * 0.2,
    });

    tl.to(image, {
      keyframes: [
        {
          y: isEven ? randomOffset : 0,
          x: isEven ? 0 : randomOffset,
          duration: 0.3,
          opacity: 0
        },
        {
          autoAlpha: 1,
          x: 0,
          y: 0,
          duration: 0.3,
          ease: "power2.out",
          opacity: 1
        },
        {
          delay: 3,
          y: isEven ? 0 : randomOffset,
          x: isEven ? randomOffset : 0,
          duration: 0.3,
          ease: "power2.in",
        },
      ],
    }).set(image, {
      autoAlpha: 0,
    });
  });


/** ---- Portfolio Gallery JS ---- **/

  if (document.querySelector('#portfolio-slider')) {

    const bannerSlider = new Splide('#portfolio-slider', {
      type: 'loop',
      drag: 'free',
      perPage: 5,
      gap: '1rem',
      arrows: false,
      pagination: false,
      breakpoints: {
        899: {
          type: 'none',
          perPage: 3.2,
          drag: 'free',
          snap: true,
          gap: '1rem',
        },
        600: {
          type: 'none',
          perPage: 2.2,
          drag: 'free',
          snap: true,
          gap: '0.5rem'
        }
      },
    }).mount();
  }


/** ---- MM Service Slider JS ---- **/

  function handleAnimation(target) {
    let duration = 1;
    TweenMax.to(target, duration / 4, { y: -50, ease: Power2.easeOut });
    TweenMax.to(target, duration / 2, {
      y: 0,
      ease: Bounce.easeOut,
      delay: duration / 4
    });
  }

  // Options for the Intersection Observer
  const serivceIntersection = {
    root: null,
    rootMargin: '0px',
    threshold: 0.5 // Trigger when 50% of the element is in the viewport
  };

  const targetElement = document.querySelectorAll(".caption_ball");

  function handleIntersection(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        handleAnimation(entry.target);
      }
    });
  }

  targetElement.forEach(element => {
    const serviceObserver = new IntersectionObserver(handleIntersection, serivceIntersection);
    serviceObserver.observe(element);
  });

  if(document.querySelector(".caption_ball")){
    document.querySelector(".caption_ball").addEventListener("mouseenter", handleAnimation(targetElement));
  }


  document.querySelectorAll(".caption_ball").forEach(element => {
    element.addEventListener("mouseenter", function () {
      let duration = 1;
      TweenMax.to(this, duration / 4, { y: -50, ease: Power2.easeOut });
      TweenMax.to(this, duration / 2, {
        y: 0,
        ease: Bounce.easeOut,
        delay: duration / 4
      });
    });
  });




/* ---- Home Partners Logo's Slider ---- */

  if (document.querySelector('#partners-slider')) {

    var bannerSlider = new Splide('#partners-slider', {
      type: 'loop',
      drag: 'free',
      perPage: 5,
      gap: '2rem',
      arrows: false,
      pagination: false,

      /* To Enable AutoScroll, Uncomment the autoscroll object & 
          pass this line : window.splide.Extensions as an 
          argument to the mount 
          Ex: .mount(window.splide.Extensions)
      */

      // autoScroll: {
      //     speed: 1,
      //     pauseOnHover: true,
      // },

      breakpoints: {
        749: {
          perPage: 2,
          drag: 'free',
          snap: true,
          gap: '1rem',
          pagination: false,
          autoScroll: false
        },
      }
    }).mount();
  }


/** ---- Awards Section JS ---- **/

  const awwSlider = document.getElementById('awards-slider');
  if (awwSlider) {
    const bannerSlider = new Splide('#awards-slider', {
      loop: true,
      drag: 'free',
      perPage: 3,
      gap: '2rem',
      arrows: false,
      pagination: false,
      breakpoints: {
        600: {
          perPage: 1,
          drag: 'free',
          gap: '0.5rem'
        }
      },
    }).mount();
  }




